import React, { useState } from "react";
 import axios from "axios";
 const API_URL = process.env.REACT_APP_API_URL;
export default function Register() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    role: "student",
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };



const handleSubmit = async (e) => {
  e.preventDefault();
  setError("");
  setSuccess("");
    setLoading(true);

  if (formData.password !== formData.confirmPassword) {
    setError("Passwords do not match");
      setLoading(false);
    return;
  }

  try {
    const res = await axios.post(`${API_URL}/api/auth/register`, formData);

    const data = res.data;

    localStorage.setItem("token", data.token);
    setSuccess("Registration successful!");

    setTimeout(() => {
      if (formData.role === "student") {
        window.location.href = "/student/dashboard";
       
      } else if (formData.role === "teacher") {
        window.location.href = `/teacherDetail?userId=${data.userId}`;
      }
    }, 2000);
  } catch (err) {
    setError("Server error. Please try again later.");
      setLoading(false);
  }
};


  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-r from-blue-600 via-purple-700 to-pink-600 px-6 py-12">
      <form
        onSubmit={handleSubmit}
        className="bg-white rounded-xl shadow-2xl p-10 max-w-md w-full"
      >
        <h2 className="text-3xl font-extrabold mb-8 text-center text-gray-900 tracking-wide">
          Create an Account
        </h2>

        {error && (
          <p className="mb-6 text-center text-red-700 bg-red-100 rounded-md py-2 px-4 font-medium">
            {error}
          </p>
        )}
        {success && (
          <p className="mb-6 text-center text-green-700 bg-green-100 rounded-md py-2 px-4 font-medium">
            {success}
          </p>
        )}

        {/* Name */}
        <label htmlFor="name" className="block mb-2 font-semibold">
          Full Name
        </label>
        <input
          id="name"
          type="text"
          name="name"
          required
          value={formData.name}
          onChange={handleChange}
          placeholder="Your full name"
          className="w-full p-3 border rounded-lg mb-6"
        />

        {/* Email */}
        <label htmlFor="email" className="block mb-2 font-semibold">
          Email Address
        </label>
        <input
          id="email"
          type="email"
          name="email"
          required
          value={formData.email}
          onChange={handleChange}
          placeholder="example@mail.com"
          className="w-full p-3 border rounded-lg mb-6"
        />

        {/* Password */}
        <label htmlFor="password" className="block mb-2 font-semibold">
          Password
        </label>
        <input
          id="password"
          type="password"
          name="password"
          required
          value={formData.password}
          onChange={handleChange}
          placeholder="Password"
          className="w-full p-3 border rounded-lg mb-6"
        />

        {/* Confirm Password */}
        <label htmlFor="confirmPassword" className="block mb-2 font-semibold">
          Confirm Password
        </label>
        <input
          id="confirmPassword"
          type="password"
          name="confirmPassword"
          required
          value={formData.confirmPassword}
          onChange={handleChange}
          placeholder="Confirm password"
          className="w-full p-3 border rounded-lg mb-6"
        />

        {/* Role */}
        <label htmlFor="role" className="block mb-2 font-semibold">
          Register as
        </label>
        <select
          id="role"
          name="role"
          value={formData.role}
          onChange={handleChange}
          className="w-full p-3 border rounded-lg mb-6"
        >
          <option value="student">Student</option>
          <option value="teacher">Teacher</option>
        </select>

        {/* Submit Button */}
       



   <button
          type="submit"
          disabled={loading}
          className={`w-full bg-gradient-to-r from-blue-600 to-purple-700 text-white font-bold py-3 rounded-lg shadow-lg transition duration-300 hover:opacity-90 ${
            loading ? "opacity-50 cursor-not-allowed" : "hover:bg-blue-700"
          }`}
        >
          {loading ? "Registering..." : "Register"}
        </button>


        {/* Link to login */}
        <p className="mt-6 text-center text-sm">
          Already have an account?{" "}
          <a
            href="/login"
            className="text-blue-700 hover:underline font-medium"
          >
            Login here
          </a>
        </p>
      </form>
    </div>
  );
}
